/** biome-ignore-all lint/style/useNamingConvention: node type registry keys */

const table_simple = {
	group: "block",
	content: "tableCell_simple*",
};

const tableHeaderRow_simple = {
	group: "block",
	content: "tableHeader_simple+",
};

const tableBodyRow_simple = {
	group: "block",
	content: "tableCell_simple+",
};

const tableHeader_simple = {
	group: "block",
	content: "inline+",
	// A column states its alignment once, in the delimiter row, and its width once, in the header
	// cell -- where the user set it by dragging the border of that column.
	attrs: {
		align: { default: null },
		colwidth: { default: null },
	},
};

const tableCell_simple = {
	group: "block",
	content: "inline+",
};

export { table_simple, tableBodyRow_simple, tableCell_simple, tableHeader_simple, tableHeaderRow_simple };
